import React from 'react';
import { AccountForm } from './AccountForm';

export const LoginForm = ({ onAddAccount, onSignOut, userEmail }) => {
  return (
    <div className="form-container">
      <div className="brand-mark" aria-hidden="true">DO</div>
      <h2 className="form-title">DigitalOcean FinOps Dashboard</h2>
      <p className="intro-text">
        Connect your DigitalOcean account(s) to visualize and analyze your billing data.
        You'll need an API token with read access to your billing data.
      </p>

      <AccountForm
        onSubmit={onAddAccount}
        submitLabel="Connect Account"
        showHelp
        fullWidthSubmit
      />

      <div className="data-security-note">
        <p><strong>Note:</strong> Your API tokens are stored only in your browser's local storage and are never sent to any third-party servers.</p>
      </div>

      {onSignOut && (
        <p className="signed-in-as">
          {userEmail ? <>Signed in as <strong>{userEmail}</strong>. </> : null}
          <button type="button" className="link-button" onClick={onSignOut}>Sign out</button>
        </p>
      )}
    </div>
  );
};
